import { Paths } from '../../lib/constants/path'
import { RoleEnum } from '../../lib/types/enums/users/role.enum'
import { Route } from '../../lib/types/routes'
import TripFolderDetailsPage from './trip-folder-details'
import TripFolderListPage from './trip-folder-list'

const tripFolderRoutes: Route[] = [
  {
    path: Paths.TRIP_FOLDER_LIST_PAGE,
    element: <TripFolderListPage />,
    roles: [RoleEnum.ADMIN]
  },
  {
    path: Paths.TRIP_FOLDER_DETAILS_PAGE,
    element: <TripFolderDetailsPage />,
    roles: [RoleEnum.ADMIN]
  }
]

export default tripFolderRoutes
